<template>
   <div>
      <atom-title
         title="Forgot Password"
         :color="formSubmitted ? 'success' : 'secondary'"
      />
      <form v-if="!formSubmitted" @submit.prevent="handleSubmit">
         <error-list
            :errors="errors.non_field"
         />
         <input-field
            label="Enter your email address and password reset link will be sent to your mail"
            placeholder="Enter you email"
            type="email"
            v-model="email"
            :errors="errors.email"
            required
         />
         <submit-btn
            :isLoading="isSubmitting"
            label="Request password reset"
            loadingLabel="Requesting"
         />
      </form>
      <success-msg
         :isSuccess="formSubmitted"
         text="The password reset request was successful. Please check your
         email and go to the link to reset password sent in the mail."
      />
   </div>
</template>

<script>
import AtomTitle from '../../../atoms/Login/Title';
import ErrorList from '../../../molecules/Login/Errors';
import InputField from '../../../molecules/Login/InputField';
import SubmitBtn from '../../../molecules/Login/SubmitBtn';
import SuccessMsg from '../../../molecules/Register/SuccessMsg';

import { mapActions } from 'vuex';

export default {
   name: 'PasswordResetForm',
   components: {
      AtomTitle,
      InputField,
      SubmitBtn,
      ErrorList,
      SuccessMsg,
   },
   data()
   {
      return {
         email: "",
         errors: {
            email: [],
            non_field: [],
         },
         formSubmitted: false,
         isSubmitting: false,
      }
   },
   methods: {
      ...mapActions('users', ['requestPasswordReset']),
      clearError()
      {
         this.errors = {email: [], non_field: []}; 
      },
      async handleSubmit()
      {
         if (this.isSubmitting) return;
         this.isSubmitting = true;
         this.clearError();
         try
         {
            await this.requestPasswordReset(this.email)
            this.formSubmitted = true;
         }
         catch (error)
         {
            if (!error.response)
            {
               this.errors.non_field = ["Couldn't connect to server. (Please check internet connection)"];
            }
            else if (error.response.status===400) // bad request errors
            {
               const { email } = error.response.data;
               this.errors.email = email ? email : [];
            }
            else
            {
               this.errors.non_field = [error.message];
            }
         }
         this.isSubmitting = false;
      },
   }
}
</script>
